<span class="container" *ngIf="!editMode">
  <span class="text">{{option.text}}</span>
  <span class="blocked" *ngIf="blockedOptionNames.length > 0">
    <mat-icon class="blocked-icon" aria-hidden="true">block</mat-icon>
    <span class="blocked-list">{{blockedOptionNames.join(', ')}}</span>
  </span>
  <span class="buttons" *ngIf="!readonly">
    <button mat-icon-button
            matTooltip="Редактировать"
            (click)="onEdit($event)">
      <mat-icon>edit</mat-icon>
    </button>
    <button mat-icon-button
            matTooltip="Удалить ответ"
            (click)="onDelete($event)">
      <mat-icon>delete</mat-icon>
    </button>
  </span>
</span>

<form class="editor" *ngIf="!readonly && editMode"
      [formGroup]="form" (ngSubmit)="onSubmit($event)">
  <mat-form-field>
    <mat-label>Ответ</mat-label>
    <textarea #input matInput formControlName="text"
              placeholder="Введите ответ"
              cdkTextareaAutosize
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
              [autofocus]="['autofocus']" rows="2"></textarea>
  </mat-form-field>
  <mat-form-field *ngIf="availableOptions.length > 0" class="blocked-options">
    <mat-label>Блокируемые ответы</mat-label>
    <mat-select formControlName="blockedOptionIds" multiple
                placeholder="Выберите ответы для блокировки">
      <mat-option *ngFor="let availableOption of availableOptions" [value]="availableOption.id">
        {{availableOption.text}}
      </mat-option>
    </mat-select>
    <mat-hint>Выбранные ответы будут автоматически сниматься при выборе этого варианта.</mat-hint>
  </mat-form-field>
  <div class="buttons">
    <button mat-icon-button
            matTooltip="Сохранить"
            type="submit"
            (click)="onSubmit($event)">
      <mat-icon>done</mat-icon>
    </button>
    <button mat-icon-button
            matTooltip="Отмена"
            type="button"
            (click)="onCancel($event)">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</form>

